
export default {
  menuListItemStyle: {
    padding: 2,
    paddingLeft: 10,
    backgroundColor: '',
  },
  menuListInnerDivStyle: {
    paddingLeft: 50,
    paddingTop: 20,
    letterSpacing: 0,
  },
  iconStyle: {
    fontSize: 16,
    top: 6,
  },
  footerStyle: {
    all: {
      textAlign: 'left',
      position: 'absolute',
      bottom: 0,
      width: '100%',
      display: 'inline-box',
    },
    image: {
      backgroundColor: 'transparent',
      width: 200,
      verticalAlign: 'middle',
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 15,
    },
    divIcon: {
      position: 'absolute',
      bottom: 5,
      width: '100%',
      verticalAlign: 'middle',
    },
    iconStyle: {
      fontSize: 25,
    },
  },
  listStyle: {
    padding: 0,
  },
}



// WEBPACK FOOTER //
// ./src/cmsThemes/mui/Navigation.js